import Vue from 'vue'
import axios, { AxiosInstance, AxiosRequestHeaders } from 'axios'
import CacheStore from '@/store/cache-store'

const crossOriginUriCollection = new Array<string>()
crossOriginUriCollection.push('*')

axios.defaults.baseURL = process.env.VUE_APP_BASE_API_URL
axios.defaults.headers.common['Access-Control-Allow-Origin'] = crossOriginUriCollection.join(',')
axios.defaults.headers.common['Cache-Control'] = 'no-cache'
axios.defaults.headers.common.Pragma = 'no-cache'
axios.defaults.headers.get.Expires = -1
axios.defaults.headers.post['Content-Type'] = 'application/json'

declare module 'vue/types/vue' {
    // eslint-disable-next-line no-unused-vars
    interface Vue {
        $http: AxiosInstance;
    }
}

const instance = axios.create()
instance.interceptors.request.use((config) => {
  const token = CacheStore.getFromSession(CacheStore.TOKEN)
  if (token) {
    if (!config.headers) {
      config.headers = {} as AxiosRequestHeaders
    }
    config.headers.Authorization = `Bearer ${token}`
  }

  return config
})

instance.interceptors.response.use(response => {
  return response
}, error => {
  if (error.response && error.response.status === 401) {
    localStorage.removeItem('token')
    window.location.reload()
  }
  return error
})
Vue.prototype.$http = instance

export default instance
